import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-671289f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-h5 font-weight-bold" }, "Detalle del equipo", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Equipo:", -1))
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Capitán:", -1))
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Fecha:", -1))
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-h6 font-weight-bold text-center" }, " Miembros del equipo ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", null, "Lista"),
    /*#__PURE__*/_createElementVNode("th", null, "Acciones")
  ])
], -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 1,
  colspan: "3"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "text-center"
}
const _hoisted_21 = { class: "text-subtitle-1 text-center" }

import { ref, onMounted, computed } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";
import LoadingGandalf from "../Commons/LoadingGandalf.vue";
import { ComponentesEquipoDTO, InscripcionEquipoDTO } from "@/interfaces/Inscripcion";
import {
  eliminarMiembroEquipoAsync,
  getInscripcionEquipo,
} from "@/services/InscripcionesService";
import { useAuth } from "@/composables/useAuth";
import ModalVerLista from "./ModalVerLista.vue";
import ModalEnviarLista from "./ModalEnviarLista.vue";
import { convertirFecha } from "@/utils/Fecha";

import {
  CrearListaTorneoRequestDTO,
  ModificarListaTorneoRequestDTO,
  ListaJugador,
  RequesListaDTO,
} from "@/interfaces/Lista";
import { subirListaTorneo, modificarListaTorneo } from "@/services/ListasService";
import ModalAddMiembroEquipo from "../GestionTorneos/Equipos/ModalAddMiembroEquipo.vue";
import { UsuarioSinEquipoDTO } from "@/interfaces/Usuario";
import { getUsuariosNoInscritosTorneoAsync } from "@/services/UsuariosService";
import { getTorneo } from "@/services/TorneosService";
import { Torneo } from "@/interfaces/Torneo";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalInscripcionEquipo',
  props: {
    idInscripcion: {},
    idUsuario: {},
    idTorneo: {},
    idOrganizador: {}
  },
  emits: ["close", "eliminar-inscripcion-equipo"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const numeroMiembrosEquipo = ref<number>();
const equipoConHuecos = computed(() => {
  const miembros = inscripcionData.value?.componentesEquipoDTO ?? [];
  const faltantes = Math.max(0, (numeroMiembrosEquipo.value ?? 0) - miembros.length);
  return [...miembros, ...Array(faltantes).fill(null)];
});


const show = ref(true);
const showSuccessModalEliminar = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const { getidUsuario } = useAuth();

const isCargandoAccion = ref(false);
const mensajeCarga = ref("Cargando...");
const idUsuarioLogger = ref<number>(parseInt(getidUsuario.value));
const isLoading = ref<boolean>(true);
const isCaptain = ref<boolean>(false);
const idCaptain = ref<number>();
const detalleTorneo = ref<Torneo>();
const inscripcionData = ref<InscripcionEquipoDTO>({
  idTorneo: 0,
  idCapitan: 0,
  nombreEquipo: "",
  miembros: [],
  idInscripcion: 0,
  idUsuario: 0,
  idEquipo: 0,
  idOrganizador: 0,
  emailOrganizador: "",
  componentesEquipoDTO: [],
});

const currentInscripcionId = ref<number>();
const currentIdLista = ref<number>(0);
const currentUsuarioId = ref<number>();
const currentEmailOrganziador = ref<string>();
const currentNick = ref<string>();
const currentTorneoId = ref<number>();

const showVerListaModal = ref<boolean>(false);
const showEnviarCambiarListaModal = ref<boolean>(false);

const hasLista = ref<boolean>(false);
const showSuccessModalLista = ref<boolean>(false);
const showErrorModalLista = ref<boolean>(false);
const showModalRegistrarMiembroEquipo = ref<boolean>(false);
const showErrorModalEliminarMiembroEquipo = ref<boolean>(false);
const showSuccessModalEliminarMiembroEquipo = ref<boolean>(false);

const listaJugador = ref<ListaJugador>();
const idTorneo = ref<number>();
const jugadoresSinEquipo = ref<UsuarioSinEquipoDTO[]>([]);

const verLista = (listaData: string, nombre: string, ejercito: string) => {
  const listaJugadorDTO: ListaJugador = {
    listaData: listaData,
    nick: nombre,
    nombreEjercito: ejercito,
  };
  listaJugador.value = listaJugadorDTO;
  showVerListaModal.value = true;
};

const eliminarMiembro = async (idInscripcion: number) => {
  isCargandoAccion.value = true;
  mensajeCarga.value = "Eliminando jugador...";
  try{
    const response = await eliminarMiembroEquipoAsync(idInscripcion);
  
    if (response.status !== 200) {
      isCargandoAccion.value = false;
      showErrorModalEliminarMiembroEquipo.value = true;
      return;
    }
  
    inscripcionData.value.componentesEquipoDTO = inscripcionData.value.componentesEquipoDTO.filter(
      (miembro) => miembro.idInscripcion !== idInscripcion
    );
  }
  catch(error){
    console.error("Error al borrar un miembro: ", error);
  }finally{
    isCargandoAccion.value = false;
    showSuccessModalEliminarMiembroEquipo.value = true;
  }
};


const handlerModalRegistrarMiembroEquipo = async () => {
  const responseJugadores = await getUsuariosNoInscritosTorneoAsync(
    inscripcionData.value.idTorneo
  );
  jugadoresSinEquipo.value = (responseJugadores?.data ?? []).sort(
    (a: { nick: string }, b: { nick: string }) => a.nick.localeCompare(b.nick)
  );
  showModalRegistrarMiembroEquipo.value = true;
};

const closeModal = () => {
  showModalRegistrarMiembroEquipo.value = false;
};

const closeConfigModal = (nuevoMiembro: ComponentesEquipoDTO) => {
  if (nuevoMiembro) {
    // Evitar duplicados por ID
    if (
      !inscripcionData.value.componentesEquipoDTO.some(
        (m) => m.idUsuario === nuevoMiembro.idUsuario
      )
    ) {
      inscripcionData.value.componentesEquipoDTO.push(nuevoMiembro);
    }
  }
};



const enviarCambiarLista = (
  idInscripcion: number | undefined,
  listaData: string,
  idUsuario: number,
  nick: string,
  idLista: number
) => {
  currentInscripcionId.value = idInscripcion;
  currentUsuarioId.value = idUsuario;
  currentNick.value = nick;
  currentIdLista.value = idLista;
  if (!listaData) hasLista.value = false;
  else hasLista.value = true;

  showEnviarCambiarListaModal.value = true;
};

const eliminarInscripcion = async (idEquipo: number) => {
  emit("eliminar-inscripcion-equipo", idEquipo);
  show.value = false;
  emit("close");
};
const close = () => {
  show.value = false;
  emit("close");
};

const guardarLista = async (newLista: RequesListaDTO) => {
  isCargandoAccion.value = true;
  const miembroIndex = inscripcionData.value.componentesEquipoDTO.findIndex(
    (m) => m.idInscripcion === currentInscripcionId.value
  );

  if (miembroIndex === -1) {
    isCargandoAccion.value = false;
    showErrorModalLista.value = true;
    return;
  }

  const miembro = inscripcionData.value.componentesEquipoDTO[miembroIndex];

  const esModificacion = !!miembro.idLista;

  try {
    let nuevoIdLista = miembro.idLista;

    if (esModificacion) {
      mensajeCarga.value = "Modificando lista...";

      const requestLista: ModificarListaTorneoRequestDTO = {
        idInscripcion: currentInscripcionId.value!,
        idLista: miembro.idLista!,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: inscripcionData.value.idTorneo,
      };

      await modificarListaTorneo(requestLista);
    } else {
      mensajeCarga.value = "Enviando lista...";

      const requestLista: CrearListaTorneoRequestDTO = {
        idInscripcion: currentInscripcionId.value!,
        listaData: newLista.listaData,
        ejercito: newLista.ejercito,
        idUsuario: newLista.idUsuario,
        idTorneo: inscripcionData.value.idTorneo,
        emailOrganizador: inscripcionData.value.emailOrganizador,
        nick: newLista.nick,
        nombreEquipo: inscripcionData.value.nombreEquipo,
      };

      const response = await subirListaTorneo(requestLista);
      nuevoIdLista = response.data?.idLista;
    }

    // Reemplazo reactivo del objeto completo
    inscripcionData.value.componentesEquipoDTO[miembroIndex] = {
      ...miembro,
      estadoLista: "ENTREGADA",
      listaData: newLista.listaData,
      ejercito: newLista.ejercito.name,
      idLista: nuevoIdLista,
    };

    showSuccessModalLista.value = true;
  } catch (error) {
    console.error("Error al guardar/modificar lista:", error);
    showErrorModalLista.value = true;
  } finally {
    isCargandoAccion.value = false;
  }
};


onMounted(async () => {
  try {
    isLoading.value = true;
    const response = await getInscripcionEquipo(props.idInscripcion!);

    inscripcionData.value = response.data;
    idTorneo.value = inscripcionData.value.idTorneo;

    if (inscripcionData.value?.idCapitan == idUsuarioLogger.value) {
      isCaptain.value = true;
      idCaptain.value = idUsuarioLogger.value;
    }

    if (idTorneo.value){
      try{
        //Obtenemos datos del torneo para saber cuantos miembros tiene el equipo
        const responseTorneo = await getTorneo(idTorneo.value);
        detalleTorneo.value = responseTorneo.data;
    
        const miembrosPorTipo: Record<string, number> = {
          Individual: 1,
          Parejas: 2,
          Equipos_4: 4,
          Equipos_6: 6,
        };
        numeroMiembrosEquipo.value = miembrosPorTipo[detalleTorneo.value?.tipoTorneo ?? "Individual"] || 1;
        
      }catch (error){
        console.error("Error al obtener el detalle del torneo:", error);
      }
    }
  } catch (error) {
    console.error("Error al obtener datos de la inscripcion:", error);
  }
  finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingGandalf)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ 'loading-overlay': isCargandoAccion.value })
        }, [
          _createVNode(_component_v_container, {
            modelValue: show.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
            class: "d-flex justify-center align-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                elevation: "8",
                class: "rounded-modal pa-3 scrollable-modal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "modal-title d-flex align-center justify-space-between px-4 py-3" }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_v_btn, {
                        icon: "",
                        onClick: close,
                        class: "close-button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "grey darken-1" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card, { class: "info-card pa-4 mt-4 mx-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            class: "align-center pt-1 pb-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "blue",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-shield-account")
                                ]),
                                _: 1
                              }),
                              _hoisted_3,
                              _createElementVNode("span", _hoisted_4, _toDisplayString(inscripcionData.value?.nombreEquipo), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            class: "align-center pt-1 pb-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "amber",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-crown")
                                ]),
                                _: 1
                              }),
                              _hoisted_5,
                              _createElementVNode("span", _hoisted_6, _toDisplayString(inscripcionData.value?.componentesEquipoDTO.find(
                  (c) => c.idUsuario === inscripcionData.value?.idCapitan
                )?.nick || "Desconocido"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            class: "align-center pt-1 pb-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "green",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-calendar")
                                ]),
                                _: 1
                              }),
                              _hoisted_7,
                              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(convertirFecha)(inscripcionData.value?.fechaInscripcion!)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            class: "align-center pt-1 pb-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_chip, {
                                class: "mt-1",
                                color: inscripcionData.value?.esPago === 'SI' ? 'green' : 'red',
                                variant: "tonal",
                                "x-small": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "16",
                                    class: "me-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-cash")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" Pago: " + _toDisplayString(inscripcionData.value?.esPago), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider, { class: "my-4" }),
                  _hoisted_9,
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_ctx.$vuetify.display.xs)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_table, { dense: "" }, {
                                    default: _withCtx(() => [
                                      _hoisted_10,
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipoConHuecos.value, (miembro, index) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: miembro?.idUsuario || 'hueco-' + index
                                          }, [
                                            miembro
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createElementVNode("td", null, [
                                                    (miembro.idUsuario === inscripcionData.value?.idCapitan)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          color: "amber darken-2"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-crown")
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(miembro.nick), 1)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    (miembro.listaData)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                                          (miembro.estadoLista === 'OK')
                                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                key: 0,
                                                                color: "green"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("mdi-check")
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : (miembro.estadoLista === 'ENTREGADA')
                                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                  key: 1,
                                                                  color: "blue"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode("mdi-send")
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                              : (_openBlock(), _createBlock(_component_v_icon, {
                                                                  key: 2,
                                                                  color: "red"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode("mdi-close-circle")
                                                                  ]),
                                                                  _: 1
                                                                }))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                          _createVNode(_component_v_icon, { color: "red" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("mdi-email-off")
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]))
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createVNode(_component_v_menu, { "offset-y": "" }, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createVNode(_component_v_btn, _mergeProps({
                                                          color: "primary",
                                                          variant: "tonal"
                                                        }, props), {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode("mdi-dots-vertical")
                                                              ]),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 2
                                                        }, 1040)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list, null, {
                                                          default: _withCtx(() => [
                                                            (miembro.listaData)
                                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                  key: 0,
                                                                  onClick: _withModifiers(($event: any) => (
                                verLista(
                                  miembro.listaData,
                                  miembro.nick,
                                  miembro.ejercito!
                                )
                              ), ["stop"])
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, { class: "me-2" }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode("mdi-eye")
                                                                          ]),
                                                                          _: 1
                                                                        }),
                                                                        _createTextVNode(" Ver Lista ")
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]))
                                                              : _createCommentVNode("", true),
                                                            (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                  key: 1,
                                                                  onClick: _withModifiers(($event: any) => (enviarCambiarLista(miembro.idInscripcion,miembro.listaData!,miembro.idUsuario,miembro.nick,miembro.idLista)), ["stop"])
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, { class: "me-2" }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode("mdi-pencil")
                                                                          ]),
                                                                          _: 1
                                                                        }),
                                                                        (miembro.listaData)
                                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Modificar lista"))
                                                                          : (_openBlock(), _createElementBlock("span", _hoisted_14, "Enviar lista"))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]))
                                                              : _createCommentVNode("", true),
                                                            (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                  key: 2,
                                                                  onClick: _withModifiers(($event: any) => (eliminarMiembro(miembro.idInscripcion)), ["stop"])
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_v_icon, {
                                                                          color: "red",
                                                                          class: "me-2"
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createTextVNode("mdi-account-remove")
                                                                          ]),
                                                                          _: 1
                                                                        }),
                                                                        _createTextVNode(" Eliminar del equipo ")
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ])
                                                ], 64))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                                  (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        variant: "tonal",
                                                        color: "primary",
                                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handlerModalRegistrarMiembroEquipo())),
                                                        class: "elevated-btn",
                                                        block: ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { class: "mr-1" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("mdi-menu")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(" Añadir jugador ")
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]))
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(equipoConHuecos.value, (miembro, index) => {
                                return (_openBlock(), _createBlock(_component_v_col, {
                                  key: miembro?.idUsuario || 'hueco-' + index,
                                  cols: "12",
                                  sm: "6",
                                  md: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                      class: "pa-3 player-card",
                                      elevation: "20"
                                    }, {
                                      default: _withCtx(() => [
                                        miembro
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createVNode(_component_v_card_title, { class: "text-body-1 font-weight-bold d-flex align-center" }, {
                                                default: _withCtx(() => [
                                                  (miembro.idUsuario === inscripcionData.value?.idCapitan)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "amber darken-2"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("mdi-crown")
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  _createTextVNode(" " + _toDisplayString(miembro.nick), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_divider),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  (miembro.ejercito)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(miembro.ejercito), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_17, "Estado de la lista:")),
                                                  _createVNode(_component_v_chip, {
                                                    color: 
                        miembro.estadoLista === 'OK'
                          ? 'green'
                          : miembro.estadoLista === 'ENTREGADA'
                          ? 'blue'
                          : 'red'
                      ,
                                                    variant: "tonal"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(miembro.estadoLista), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_divider),
                                              _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn, _mergeProps({
                                                        color: "primary",
                                                        variant: "tonal"
                                                      }, props), {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, null, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("mdi-menu")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(" Acciones ")
                                                        ]),
                                                        _: 2
                                                      }, 1040)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list, null, {
                                                        default: _withCtx(() => [
                                                          (miembro.listaData)
                                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: 0,
                                                                onClick: _withModifiers(($event: any) => (
                            verLista(
                              miembro.listaData,
                              miembro.nick,
                              miembro.ejercito!
                            )
                          ), ["stop"])
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_icon, { class: "me-2" }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode("mdi-eye")
                                                                        ]),
                                                                        _: 1
                                                                      }),
                                                                      _createTextVNode(" Ver Lista ")
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                            : _createCommentVNode("", true),
                                                          (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: 1,
                                                                onClick: _withModifiers(($event: any) => (
                            enviarCambiarLista(
                              miembro.idInscripcion,
                              miembro.listaData!,
                              miembro.idUsuario,
                              miembro.nick,
                              miembro.idLista
                            )
                          ), ["stop"])
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_icon, { class: "me-2" }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode("mdi-pencil")
                                                                        ]),
                                                                        _: 1
                                                                      }),
                                                                      (miembro.listaData)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Modificar lista"))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "Enviar lista"))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                            : _createCommentVNode("", true),
                                                          (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: 2,
                                                                onClick: _withModifiers(($event: any) => (eliminarMiembro(miembro.idInscripcion)), ["stop"])
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_icon, {
                                                                        color: "red",
                                                                        class: "me-2"
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode("mdi-account-remove")
                                                                        ]),
                                                                        _: 1
                                                                      }),
                                                                      _createTextVNode(" Eliminar del equipo ")
                                                                    ]),
                                                                    _: 1
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onClick"]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createVNode(_component_v_card_title, { class: "text-body-1 font-weight-bold d-flex align-center text-grey" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    class: "mr-1",
                                                    color: "yellow"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-account-outline")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" Slot vacío ")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_divider),
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_chip, {
                                                    color: "yellow",
                                                    variant: "tonal"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Pendiente ")
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_divider),
                                              (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                                ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                                    key: 0,
                                                    class: "justify-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_btn, {
                                                        variant: "tonal",
                                                        color: "primary",
                                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (handlerModalRegistrarMiembroEquipo())),
                                                        class: "elevated-btn",
                                                        block: ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_icon, { class: "mr-1" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode("mdi-menu")
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(" Añadir jugador ")
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                    ? (_openBlock(), _createBlock(_component_v_divider, {
                        key: 0,
                        class: "my-4"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              (inscripcionData.value?.idCapitan == _ctx.idUsuario)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_v_btn, {
                                      color: "red-darken-3",
                                      variant: "tonal",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (eliminarInscripcion(inscripcionData.value?.idEquipo!))),
                                      class: "elevated-btn",
                                      block: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Dar de baja al equipo ")
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (_ctx.$vuetify.display.xs)
                            ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    block: "",
                                    onClick: close,
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Cerrar ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 2)),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminar.value,
      message: "Inscripción eliminada.",
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => (showSuccessModalEliminar.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se ha podido actualizar la inscripción. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalVerLista, {
      isVisible: showVerListaModal.value,
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => ((showVerListaModal).value = $event)),
      listaJugador: listaJugador.value!
    }, null, 8, ["isVisible", "listaJugador"]),
    _createVNode(ModalEnviarLista, {
      isVisible: showEnviarCambiarListaModal.value,
      "onUpdate:isVisible": _cache[7] || (_cache[7] = ($event: any) => ((showEnviarCambiarListaModal).value = $event)),
      idInscripcion: currentInscripcionId.value!,
      idUsuario: currentUsuarioId.value!,
      idTorneo: currentTorneoId.value!,
      emailOrganizador: currentEmailOrganziador.value!,
      nick: currentNick.value!,
      hasLista: hasLista.value,
      onEnviarLista: guardarLista,
      onModificarLista: guardarLista
    }, null, 8, ["isVisible", "idInscripcion", "idUsuario", "idTorneo", "emailOrganizador", "nick", "hasLista"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalLista.value,
      message: "Lista enviada con éxito.",
      "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModalLista.value,
      message: "No se ha podido enviar la lista. Contacta con el administrador.",
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showErrorModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModalEliminarMiembroEquipo.value,
      message: "Miembro eliminado con éxito.",
      "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showSuccessModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModalEliminarMiembroEquipo.value,
      message: "No se ha podido eliminar al miembro del equipo. Inténtelo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showErrorModalLista.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalAddMiembroEquipo, {
      isVisible: showModalRegistrarMiembroEquipo.value,
      idEquipo: inscripcionData.value.idEquipo,
      idTorneo: idTorneo.value!,
      jugadores: jugadoresSinEquipo.value,
      onClose: closeModal,
      onConfirm: closeConfigModal
    }, null, 8, ["isVisible", "idEquipo", "idTorneo", "jugadores"]),
    _createVNode(_component_v_dialog, {
      modelValue: isCargandoAccion.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isCargandoAccion).value = $event)),
      persistent: "",
      width: "250",
      "hide-overlay": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "d-flex flex-column justify-center align-center pa-4",
          height: "180"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "50",
              class: "mb-4"
            }),
            _createElementVNode("div", _hoisted_21, _toDisplayString(mensajeCarga.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})